import type { FlightCardData } from '@massilia/queries'

import { Button, Dialog, DialogClose, DialogContent, DialogHeader, DialogTitle } from '@massilia/ui'
import { useEffect, useState } from 'react'

import { Route } from '@/routes/_booking/flights.results'
import { useFilters } from '@/utils/use-search-params'

import { FlightFilters } from './flight-filters'

interface FiltersModalProps {
  isOpen: boolean
  offers: FlightCardData[]
  onClose: () => void
}

export function FiltersModal({ isOpen, offers, onClose }: FiltersModalProps) {
  const { filters, setFilters } = useFilters(Route.id)
  const [localFilters, setLocalFilters] = useState(filters)

  useEffect(() => {
    if (isOpen) {
      setLocalFilters(filters)
    }
  }, [isOpen, filters])

  return (
    <Dialog onOpenChange={onClose} open={isOpen}>
      <DialogContent className="flex h-dvh max-h-dvh w-screen max-w-full flex-col gap-0 p-0 md:hidden">
        {/* Header fixe */}
        <DialogHeader className="border-b px-4 py-4">
          <DialogTitle>Filtres</DialogTitle>
        </DialogHeader>

        {/* Contenu scrollable */}
        <div className="flex-1 overflow-y-auto px-4 py-4">
          <FlightFilters offers={offers} />
        </div>

        {/* Footer fixe */}
        <div className="border-t bg-white px-4 py-3">
          <DialogClose asChild>
            <Button
              className="bg-brand-600 hover:bg-brand-700 w-full"
              onClick={() => {
                setFilters(localFilters)
              }}
            >
              Appliquer
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  )
}
